import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  Checkbox,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import Namemowakel from "../../popups/Namemowakel/Namemowakel";
import Khest from "../../popups/khest/khest";
import { useReactToPrint } from "react-to-print";

import Typedawa from "../../popups/Typedawa/Typedawa";
import Degreetakade from "../../popups/degreetakade/degreetakade";
import Circles from "../../popups/Circles/Circles";
import CircleType from "../../popups/CircleType/CircleType";
import Desckhesm from "../../popups/desckhesm/desckhesm";
import Descmakel from "../../popups/descmakel/descmakel";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAllClientsKeshmAction,
  GetAllClientsMowakelAction,
  GetAllClientsTypeKesmAction,
  GetAllClientsTypeMowakAction,
} from "../../../../redux/actions/ClientAction";
import {
  GetCourtAction,
  GetLocTypeAction,
  GetLocnumberAction,
  GetTakadeAction,
  GetTypedawaAction,
} from "../../../../redux/actions/CourtAction";
import { GetAllAgencyDestinationAction } from "../../../../redux/actions/AgencyDestinationAction";
import {
  CreateDawaaAction,
  DeleteDawaaAction,
  GetAllDawaaAction,
  UpdateDawaaAction,
} from "../../../../redux/actions/DawaAction";
import notify from "../../../Notifcation";
import axios from "axios";
import DawaPrint from "../DawaPrint";
import fileDownload from "js-file-download";
import { ToastContainer } from "react-toastify";
import Mahkama from "../../popups/mahkama/mahkama";
import { useDownloadExcel } from "react-export-table-to-excel";
import Pagination from "../../../Utility/Pagination/Pagination";
const filter = createFilterOptions();
const Enter = ({
  userData,
  Datee,
  setDatee,
  Namemowakell,
  setNamemowakell,
  Sefamo,
  setSefamo,
  NameKhesm,
  setNameKhesm,
  SefaKhesm,
  setSefaKhesm,
  TypeDawa,
  setTypeDawa,
  NumberDawa,
  setNumberDawa,
  Year,
  setYear,
  Mawdodawa,
  setMawdodawa,
  TakadyDegree,
  setTakadyDegree,
  Mahkamaa,
  setMahkama,
  Numbercircle,
  setNumbercircle,
  Typecircle,
  setTypecircle,
  SummaryDawa,
  setSummaryDawa,
  Nots,
  setNots,
  setSelectedFile,
  selectedFile,
  NoteImg,
  setNoteImg,
  setDawaId,
  DawaId,
  setDawaEnded,
  DawaEnded,
  setEye,
  Eye,
  setIsEdit,
  isEdit,
}) => {
  const [FileeBase64, setBase64] = useState("");
  const [showName, setshowName] = useState(false);
  const [showKhesm, setshowKhesm] = useState(false);
  const [showTypedaw, setshowTypedaw] = useState(false);
  const [showa, setshowa] = useState(false);
  const [showdegree, setshowdegree] = useState(false);
  const [showCircle, setshowCircle] = useState(false);
  const [showCircleType, setshowCircleType] = useState(false);
  const [loading, setLoading] = useState(true);
  const [Search, setSearch] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [showSefam, setshowSefam] = useState(false);
  const myDivRefWorkcom = useRef();
  const [showSefak, setshowSefak] = useState(false);
  const PageSize = 7;

  const [showDelete, setshowDelete] = useState(false);
  const tableRef = useRef("");
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "ادارة الدعاوي",
    sheet: "ادارة الدعاوي",
  });
  const onPress = async (page) => {
    await dispatch(
      GetAllDawaaAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setDawaId(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteDawaaAction(DawaId));
    setLoading(false);
    setDawaId("");
    setshowDelete(false);
    setIsPress(false);
    setDatee("");
    setNamemowakell([]);
    setSefamo("");
    setNameKhesm([]);
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNoteImg("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };

  const ALL = useSelector((state) => state.DawaR.Getdawa);
  const ALLMowakel = useSelector((state) => state.ClientR.GetClientsMo);
  const ALLKhesm = useSelector((state) => state.ClientR.GetClientsKesm);
  const ALLTypeDawaa = useSelector((state) => state.CourtR.Dawatype);
  const ALLCircleType = useSelector((state) => state.CourtR.Loctype);
  const ALLCircelNumber = useSelector((state) => state.CourtR.LoctypeNumber);
  const ALLTakadeDegree = useSelector((state) => state.CourtR.DegreeTaqade);
  const ALLa = useSelector((state) => state.CourtR.Courts);
  const ALLKhestSefa = useSelector((state) => state.ClientR.GetClientsTypeKesm);
  const ALLMowakelSefa = useSelector((state) => state.ClientR.GetClientsTypeMo);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllClientsMowakelAction(`ClientType=Client`));
    dispatch(GetTypedawaAction());
    dispatch(GetLocTypeAction(Mahkamaa?.Id));
    dispatch(GetAllClientsTypeKesmAction("ForDefendants"));
    dispatch(GetAllAgencyDestinationAction());
    dispatch(GetCourtAction());
    dispatch(GetAllClientsTypeMowakAction("ForClient"));
    dispatch(GetAllClientsKeshmAction(`ClientType=Defendants`));
    dispatch(GetTakadeAction());
    dispatch(GetAllDawaaAction(`PageSize=${PageSize}`));
  }, []);
  useEffect(() => {
    if (Mahkamaa !== null && Typecircle !== null) {
      dispatch(
        GetLocnumberAction(
          `CourtId=${Mahkamaa.Id}&LocationTypeId=${Typecircle.Id}`
        )
      );
      dispatch(GetLocTypeAction(Mahkamaa.Id));
    }
  }, [Mahkamaa, Typecircle]);

  useEffect(() => {
    dispatch(GetAllDawaaAction(`SearchTerm=${Search}&PageSize=${PageSize}`));
  }, [Search]);
  const handleCloseSefam = () => {
    setshowSefam(false);
    dispatch(GetAllClientsTypeMowakAction("ForClient"));
  };
  const handleShowSefam = () => setshowSefam(true);

  const handleCloseSefak = () => {
    setshowSefak(false);
    dispatch(GetAllClientsTypeKesmAction("ForDefendants"));
  };
  const handlePrint = useReactToPrint({
    content: () => myDivRefWorkcom.current,
  });

  const handleShowSefak = () => setshowSefak(true);

  const handleCloseCircleType = () => {
    setshowCircleType(false);
    dispatch(GetLocTypeAction());
  };
  const handleShowCircleType = () => setshowCircleType(true);

  const handleCloseName = () => {
    setshowName(false);
    dispatch(GetAllClientsMowakelAction(`ClientType=Client`));
  };
  const handleShowName = () => setshowName(true);

  const handleCloseKhesm = () => {
    setshowKhesm(false);
    dispatch(GetAllClientsKeshmAction(`ClientType=Defendants`));
  };
  const handleShowKhesm = () => setshowKhesm(true);

  const handleCloseTypedaw = () => {
    setshowTypedaw(false);
    dispatch(GetTypedawaAction());
  };
  const handleShowTypedaw = () => setshowTypedaw(true);

  const handleClosea = () => {
    setshowa(false);
    dispatch(GetCourtAction());
  };
  const handleShowa = () => setshowa(true);

  const handleCloseDegree = () => {
    setshowdegree(false);
    dispatch(GetTakadeAction());
  };
  const handleShowDegree = () => setshowdegree(true);

  const handleCloseCircle = () => {
    setshowCircle(false);
    dispatch(
      GetLocnumberAction(
        `CourtId=${Mahkamaa?.Id}&LocationTypeId=${Typecircle?.Id}`
      )
    );
  };

  const handleShowCircle = () => setshowCircle(true);
  const converterqoma = (msg) => {
    let parts = msg.split("-");
    return parts;
  };

  const Update = (item) => {
    setIsEdit(true);
    setEye(false);
    setDawaId(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientDto.map((i) => i));
    setSefamo({ Id: item.ClientTypeId, Type: item.ClientType });
    setNameKhesm(item.DefendentDto.map((i) => i));
    setMahkama({ Id: item.CourtId, Name: item.CourtName });
    setSefaKhesm({ Id: item.DefendentTypeId, Type: item.DefendentType });
    setTypeDawa({ Id: item.LawSuitTypeId, Form: item.LawSuitType });
    setNumberDawa(() => converterqoma(item.Number)[0]);
    setYear(() => converterqoma(item.Number)[1]);
    setSummaryDawa(item.Summary || "");
    setNots(item.Note || "");
    setSelectedFile(item.FileUrl);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setDawaEnded(item.IsDone);
    setNumbercircle({
      Id: item.LocationNumberId,
      Number: item.LocationNumberName,
    });
    setTypecircle({ Id: item.LocationTypeId, Type: item.LocationTypeName });
    setTakadyDegree({ Id: item.LevelOfLawsuitId, Level: item.LevelOfLawsuit });
    setMawdodawa(item.Description || "");
  };
  const HandleShow = (item) => {
    setIsEdit(false);
    setEye(true);
    setDawaId(item.Id);
    setDatee(item.Date);
    setNamemowakell(item.ClientDto.map((i) => i));
    setSefamo({ Id: item.ClientTypeId, Type: item.ClientType });
    setNameKhesm(item.DefendentDto.map((i) => i));
    setMahkama({ Id: item.CourtId, Name: item.CourtName });
    setSefaKhesm({ Id: item.DefendentTypeId, Type: item.DefendentType });
    setTypeDawa({ Id: item.LawSuitTypeId, Form: item.LawSuitType });
    setNumberDawa(() => converterqoma(item.Number)[0]);
    setYear(() => converterqoma(item.Number)[1]);
    setSummaryDawa(item.Summary || "");
    setNots(item.Note || "");
    setSelectedFile(item.FileUrl);
    setNoteImg(item.FileDescription === null ? "" : item.FileDescription);
    setDawaEnded(item.IsDone);
    setNumbercircle({
      Id: item.LocationNumberId,
      Number: item.LocationNumberName,
    });
    setTypecircle({ Id: item.LocationTypeId, Type: item.LocationTypeName });
    setTakadyDegree({ Id: item.LevelOfLawsuitId, Level: item.LevelOfLawsuit });
    setMawdodawa(item.Description || "");
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      Datee === "" ||
      Namemowakell === "" ||
      Sefamo === "" ||
      NameKhesm === "" ||
      TypeDawa === "" ||
      NumberDawa === "" ||
      Mahkamaa === "" ||
      Typecircle === "" ||
      Numbercircle === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    if (userData.SubscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.IsActive === false &&
      userData.SubscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.SubscriptionType === "User-not-subscriped" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 دعوى إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.SubscriptionType === "Subscription-not-approved" &&
      ALL.Data &&
      ALL.Data.length > 1
    ) {
      notify("غير مسموح بأضافة اكثر من 2 دعوى إشترك للتفعيل ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Date", Datee);
    formData.append("Number", NumberDawa + "-" + Year);
    formData.append("Note", Nots);
    formData.append("Summary", SummaryDawa);
    formData.append("Description", Mawdodawa);
    formData.append(
      "CourtId",
      Mahkamaa && Mahkamaa.Id !== 0 ? Mahkamaa.Id : ""
    );
    formData.append(
      "LocationTypeId",
      Typecircle && Typecircle.Id !== 0 ? Typecircle.Id : ""
    );
    formData.append(
      "LocationNumberId",
      Numbercircle && Numbercircle.Id !== 0 ? Numbercircle.Id : ""
    );
    formData.append(
      "LawSuitFormId",
      TypeDawa && TypeDawa.Id !== 0 ? TypeDawa.Id : ""
    );
    formData.append("IsDone", DawaEnded);
    formData.append(
      "LevelOfLawSuitId",
      TakadyDegree && TakadyDegree.Id !== 0 ? TakadyDegree.Id : ""
    );
    formData.append("ClientTypeId", Sefamo?.Id);
    formData.append("FileDescription", NoteImg);
    formData.append(
      "DefendantsTypeId",
      SefaKhesm && SefaKhesm.Id !== 0 ? SefaKhesm.Id : ""
    );

    Namemowakell.map((item) => {
      return formData.append("ClientIds", item?.Id);
    });
    NameKhesm.map((item) => {
      return formData.append("DefendantsIds", item?.Id);
    });
    // formData.append(
    //   "DefendantsIds",
    //   NameKhesm.length>0?NameKhesm.map((item) => item.Id):[]
    // );
    formData.append("File", selectedFile);
    await dispatch(CreateDawaaAction(formData));
    setDatee("");
    setNamemowakell([]);
    setSefamo("");
    setNameKhesm([]);
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNoteImg("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      Datee === "" ||
      Namemowakell === "" ||
      Sefamo === "" ||
      NameKhesm === "" ||
      TypeDawa === "" ||
      NumberDawa === "" ||
      Mahkamaa === "" ||
      Typecircle === "" ||
      Numbercircle === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    if (selectedFile && selectedFile.size > 5000000) {
      notify("من فضلك يجب ان يكون حجم الملف 5 ميجا او اقل  ", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("Id", DawaId);
    formData.append("Date", Datee);
    formData.append("Number", NumberDawa + "-" + Year);
    formData.append("Note", Nots);
    formData.append("Summary", SummaryDawa);
    formData.append("Description", Mawdodawa);
    formData.append(
      "CourtId",
      Mahkamaa && Mahkamaa.Id !== 0 ? Mahkamaa.Id : ""
    );
    formData.append(
      "LocationTypeId",
      Typecircle && Typecircle.Id !== 0 ? Typecircle.Id : ""
    );
    formData.append(
      "LocationNumberId",
      Numbercircle && Numbercircle.Id !== 0 ? Numbercircle.Id : ""
    );
    formData.append(
      "LawSuitFormId",
      TypeDawa && TypeDawa.Id !== 0 ? TypeDawa.Id : ""
    );
    formData.append("IsDone", DawaEnded);
    formData.append(
      "LevelOfLawSuitId",
      TakadyDegree && TakadyDegree.Id !== 0 ? TakadyDegree.Id : ""
    );
    formData.append("ClientTypeId", Sefamo?.Id);
    formData.append("FileDescription", NoteImg);

    formData.append(
      "DefendantsTypeId",
      SefaKhesm && SefaKhesm.Id !== 0 ? SefaKhesm.Id : ""
    );
    Namemowakell.map((item) => {
      return formData.append("ClientIds", item?.Id);
    });
    NameKhesm.map((item) => {
      return formData.append("DefendantsIds", item?.Id);
    });
    // formData.append(
    //   "DefendantsIds",
    //   NameKhesm.length>0?NameKhesm.map((item) => item.Id):[]
    // );
    formData.append("NewFile", selectedFile);
    await dispatch(UpdateDawaaAction(formData));
    setDatee("");
    setNamemowakell([]);
    setSefamo("");
    setNameKhesm([]);
    setSefaKhesm("");
    setTypeDawa("");
    setNumberDawa("");
    setYear("");
    setMawdodawa("");
    setTakadyDegree("");
    setMahkama("");
    setNoteImg("");
    setNumbercircle("");
    setTypecircle("");
    setSummaryDawa("");
    setNots("");
    setBase64("");
    setIsPress(false);
    setLoading(false);
  };
  function importData() {
    let input = document.createElement("input");
    input.type = "file";
    input.multiple = "false";

    if (userData.UsedSize >= userData.SubscriptionSizeOnS3) {
      notify(
        "تم استهلاك باقة الارشيف لزيادة السعة التخزينية التواصل معنا",
        "warn"
      );
      return;
    }
    input.onchange = (e) => {
      setSelectedFile(e.target.files[0]);
      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        setBase64(base64);
      };
      reader.readAsDataURL(e.target.files[0]);
    };
    // }

    input.click();
  }
  const deleteFile = () => {
    setSelectedFile("");
    setBase64("");
  };
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  const res = useSelector((state) => state.DawaR.Adddawa);
  const UP = useSelector((state) => state.DawaR.UpdatedawaId);
  const DEL = useSelector((state) => state.DawaR.DeletedawaId);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, LawSuit created Successfully"
          ) {
            dispatch(GetAllDawaaAction(`PageSize=${PageSize}`));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.ResponseMessage === "Great, lawsuit updated Successfully"
          ) {
            dispatch(GetAllDawaaAction(`PageSize=${PageSize}`));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.StatusCode === 200 || DEL.StatusCode === 201) {
          if (
            DEL &&
            DEL.ResponseMessage === "Great, lawsuit deleted Successfully"
          ) {
            dispatch(GetAllDawaaAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.StatusCode !== 200 || DEL.StatusCode !== 201) {
          if (
            DEL &&
            DEL.ResponseMessage ===
              "Sorry, can't delete this lawsuit because it has a lawyer book"
          ) {
            notify(
              "لايمكن حذف الدعوى لانها مربوطة بالأجندة يجب حذف الأجندة اولاً",
              "warn"
            );
          } else notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {" "}
                {Datee ? new Date(Datee).toLocaleDateString("en-GB") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    التاريخ
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                type="date"
                onChange={(e) => setDatee(e.target.value)}
                value={Datee}
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Namemowakell}
                multiple
                id="tags-outlined"
                onChange={(event, newValue) => {
                  setNamemowakell(newValue);
                }}
                options={
                  ALLMowakel && ALLMowakel.Data && ALLMowakel.Data.length > 0
                    ? ALLMowakel.Data
                    : []
                }
                getOptionLabel={(option) => option.Name}
                // defaultValue={[names[13]]}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموكل
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    // placeholder="Favorites"
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowName}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Sefamo}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setSefamo({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setSefamo({
                      name: newValue.inputValue,
                    });
                  } else {
                    setSefamo(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLMowakelSefa && ALLMowakelSefa.length > 0
                    ? ALLMowakelSefa
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Type;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Type}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        صفة الموكل بالدعوى
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowSefam}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={NameKhesm}
                multiple
                id="tags-outlined"
                onChange={(event, newValue) => {
                  setNameKhesm(newValue);
                }}
                options={
                  ALLKhesm && ALLKhesm.Data && ALLKhesm.Data.length > 0
                    ? ALLKhesm.Data
                    : []
                }
                getOptionLabel={(option) => option.Name}
                // defaultValue={[names[13]]}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الخصم
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    // placeholder="Favorites"
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowKhesm}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={SefaKhesm}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setSefaKhesm({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setSefaKhesm({
                      name: newValue.inputValue,
                    });
                  } else {
                    setSefaKhesm(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLKhestSefa && ALLKhestSefa.length > 0 ? ALLKhestSefa : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Type;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Type}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label={"صفة الخصم بالدعوى"} />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowSefak}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={TypeDawa}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setTypeDawa({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setTypeDawa({
                      name: newValue.inputValue,
                    });
                  } else {
                    setTypeDawa(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLTypeDawaa && ALLTypeDawaa.length > 0 ? ALLTypeDawaa : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Form;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Form}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        نوع الدعوى
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowTypedaw}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <div className="inp-main">
                <div className="seris">
                  <TextField
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        رقم الدعوى
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    value={NumberDawa}
                    onChange={(e) => setNumberDawa(e.target.value)}
                    variant="outlined"
                    //   className="ww"
                  />
                </div>
                <div className="seris">
                  <TextField
                    inputProps={{ maxLength: 15 }}
                    type="number"
                    label="السنة"
                    variant="outlined"
                    value={Year}
                    onChange={(e) => setYear(e.target.value)}
                    //   className="ww"
                  />
                </div>
              </div>
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="موضوع الدعوى"
                variant="outlined"
                value={Mawdodawa}
                onChange={(e) => setMawdodawa(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <Autocomplete
                value={TakadyDegree}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setTakadyDegree({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setTakadyDegree({
                      name: newValue.inputValue,
                    });
                  } else {
                    setTakadyDegree(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  ALLTakadeDegree && ALLTakadeDegree.length > 0
                    ? ALLTakadeDegree
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Level;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Level}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField {...params} label="درجة التقاضي" />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowDegree}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Mahkamaa}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setMahkama({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setMahkama({
                      name: newValue.inputValue,
                    });
                  } else {
                    setMahkama(newValue);
                  }
                  setTypecircle("");
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={Array.isArray(ALLa) ? ALLa : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Name}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        المحكمة
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowa}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Typecircle}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setTypecircle({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setTypecircle({
                      name: newValue.inputValue,
                    });
                  } else {
                    setTypecircle(newValue);
                  }
                  setNumbercircle("");
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={Array.isArray(ALLCircleType) ? ALLCircleType : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Type;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Type}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        نوع الدائرة
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowCircleType}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <Autocomplete
                value={Numbercircle}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setNumbercircle({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setNumbercircle({
                      name: newValue.inputValue,
                    });
                  } else {
                    setNumbercircle(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                options={Array.isArray(ALLCircelNumber) ? ALLCircelNumber : []}
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.Number;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.Number}</li>
                )}
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        رقم الدائرة
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              <i
                className="ty fa-regular fa-pen-to-square"
                onClick={handleShowCircle}
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              <TextField
                inputProps={{ maxLength: 120 }}
                type="text"
                label="ملخص الدعوى"
                variant="outlined"
                //   className="ww"
                value={SummaryDawa}
                onChange={(e) => setSummaryDawa(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <TextField
                label="ملاحظات"
                focused
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                type="text"
                //   className="ww"
                value={Nots}
                onChange={(e) => setNots(e.target.value)}
              />
            </div>{" "}
            <div className="inp-container">
              <TextField
                label="أرشيف المستندات"
                variant="outlined"
                focused
                inputProps={{ maxLength: 120 }}
                type="text"
                value={NoteImg}
                onChange={(e) => setNoteImg(e.target.value)}
                //   className="ww"
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}></i>
            </div>
            <div className="inp-container">
              {selectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : selectedFile}
                    target="blank"
                    download={selectedFile.name}>
                    {selectedFile.name ? (
                      selectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>Attach File</div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d">
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}></i>
                  </button>
                </div>
              )}
            </div>
            <div className="inp-container">
              انتهاء الدعوى
              <Checkbox
                value={DawaEnded}
                checked={DawaEnded}
                type="checkbox"
                onChange={(e) => setDawaEnded(e.target.checked)}
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                //   className="ww"
                onChange={(e) => setSearch(e.target.value)}
                value={Search}
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
        </Container>{" "}
        <div>
          <Table
            id="my-table"
            ref={tableRef}
            className="maint"
            responsive
            striped
            bordered
            hover>
            <thead>
              <tr>
                <th>
                  التاريخ<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  صفة الموكل<i className="fa-solid fa-hashtag"></i>
                </th>
                <th>
                  الخصم<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  نوع الدعوى<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  الرقم<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  المحكمة<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  حالة الدعوى<i className="fa-regular fa-calendar-check"></i>
                </th>
                <th>
                  ارشيف المستندات{" "}
                  <i className="fa-regular fa-calendar-check"></i>
                </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
                <th className="icon-w"> </th>
              </tr>
            </thead>
            <tbody>
              {ALL && ALL.Data && ALL.Data.length > 0
                ? ALL.Data.map((item, idx) => (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{new Date(item.Date).toLocaleDateString("en-GB")}</td>
                      <td>{item.Clients}</td>
                      <td>{item.ClientType}</td>
                      <td>{item.Defendents}</td>
                      <td>{item.LawSuitType}</td>
                      <td>{converterqoma(item.Number)[0]}</td>
                      <td>{item.CourtName}</td>
                      <td>{item.IsDone ? "منتهية" : "مستمرة"}</td>
                      <td>
                        {" "}
                        {item.FileUrl !== null ? (
                          <>
                            <button
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                              }}
                              onClick={() => handleShowpopup(item.FileUrl)}>
                              {" "}
                              <i className="fa-solid fa-paperclip"></i>
                            </button>
                            <span>{item.FileDescription}</span>
                          </>
                        ) : (
                          " "
                        )}
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Update(item)}
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.Id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => HandleShow(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </Table>
        </div>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={ALL ? ALL.TotalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <Modal
        show={showName}
        onHide={handleCloseName}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الموكلين</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Namemowakel userData={userData} />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseName}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showKhesm}
        onHide={handleCloseKhesm}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الخصوم</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Khest userData={userData} />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseKhesm}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showa}
        onHide={handleClosea}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة المحاكم</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Mahkama />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" className="close" onClick={handleClosea}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>

      <Modal
        show={showTypedaw}
        onHide={handleCloseTypedaw}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة انواع الدعاوي</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Typedawa />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseTypedaw}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showdegree}
        onHide={handleCloseDegree}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة درجات التقاضي</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Degreetakade />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDegree}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCircle}
        onHide={handleCloseCircle}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الدوائر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Circles />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseCircle}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showCircleType}
        onHide={handleCloseCircleType}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة انواع الدوائر</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <CircleType />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseCircleType}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSefam}
        onHide={handleCloseSefam}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الصفات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Descmakel />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseSefam}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <Modal
        show={showSefak}
        onHide={handleCloseSefak}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>قائمة الصفات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <input className="managsearch" type="text" placeholder="أبحث" /> */}
          <Desckhesm />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseSefak}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      {/* <Modal
        show={showPdf}
        onHide={handleClosePdf}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>بيانات الدعوى</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={myDivRefWorkcom}>
            <DawaPrint
              Datee={Datee}
              Namemowakell={Namemowakell}
              Sefamo={Sefamo.Type}
              NameKhesm={NameKhesm}
              Mahkamaa={Mahkamaa.Name}
              SefaKhesm={SefaKhesm.Type}
              TypeDawa={TypeDawa.Form}
              NumberDawa={NumberDawa}
              Year={Year}
              SummaryDawa={SummaryDawa}
              Nots={Nots}
              DawaEnded={DawaEnded}
              Numbercircle={Numbercircle.Number}
              Typecircle={Typecircle.Type}
              TakadyDegree={TakadyDegree.Level}
              Mawdodawa={Mawdodawa}
            />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleClosePdf}>
            إغلاق
          </Button>
          <Button
            onClick={handlePrint}
            variant="primary"
            className="edit">
            طباعة
          </Button>
        </Modal.Footer>
      </Modal> */}
      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div ref={myDivRefWorkcom}>
        <DawaPrint
          Datee={Datee}
          Namemowakell={Namemowakell}
          Sefamo={Sefamo?.Type}
          NameKhesm={NameKhesm}
          Mahkamaa={Mahkamaa?.Name}
          SefaKhesm={SefaKhesm?.Type}
          TypeDawa={TypeDawa?.Form}
          NumberDawa={NumberDawa}
          Year={Year}
          SummaryDawa={SummaryDawa}
          Nots={Nots}
          DawaEnded={DawaEnded}
          Numbercircle={Numbercircle?.Number}
          Typecircle={Typecircle?.Type}
          TakadyDegree={TakadyDegree?.Level}
          Mawdodawa={Mawdodawa}
        />
      </div>
    </>
  );
};
export default Enter;
